import { bool } from "am-tax-fe-core";
const _env = import.meta.env;

export const settings = {
    VITE_PORT: _env.VITE_PORT ? parseInt(_env.VITE_PORT) : 5167,
    VITE_APP_MAX_FILE_NAME_LENGTH: _env.VITE_APP_MAX_FILE_NAME_LENGTH ? parseInt(_env.VITE_APP_MAX_FILE_NAME_LENGTH) : 100,
    VITE_POLLING_DELAY_MS: _env.VITE_POLLING_DELAY_MS ? parseInt(_env.VITE_POLLING_DELAY_MS) : 60000,
    VITE_CHAT_HISTORY_BY_SESSION_LIMIT: parseInt(_env.VITE_CHAT_HISTORY_BY_SESSION_LIMIT || "10"),
    VITE_BYPASS_AUTH: bool(_env.VITE_BYPASS_AUTH || "false"),
    VITE_MOCK_ENTIRE_BACKEND: bool(_env.VITE_MOCK_ENTIRE_BACKEND),
    VITE_MOCK_PARTIAL_BACKEND: bool(_env.VITE_MOCK_PARTIAL_BACKEND),
    VITE_ENABLE_REACT_QUERY_DEV_TOOLS: bool(_env.VITE_ENABLE_REACT_QUERY_DEV_TOOLS),
    VITE_DISABLE_AUTO_LOGOUT: bool(_env.VITE_DISABLE_AUTO_LOGOUT),
    VITE_ENABLE_APP_INSIGHTS: bool(_env.VITE_ENABLE_APP_INSIGHTS),
    VITE_BUILD_COMMIT: _env.VITE_BUILD_COMMIT,
    VITE_BUILD_NUMBER: _env.VITE_BUILD_NUMBER,
    VITE_APP_NAME: _env.VITE_APP_NAME,
    VITE_AZURE_CLIENT_ID: _env.VITE_AZURE_CLIENT_ID,
    VITE_AZURE_TENANT_ID: _env.VITE_AZURE_TENANT_ID,
};
